import { ResourceIdentifier } from '@cube3/common/model/resource-types';
import { addFileStub } from './addFileStub';
import { normalizeFiles } from '../v1/normalizeFiles';
import { createNestedUpload } from './createNestedUpload';

export const uploadFilesToParentResource = ({
  dispatch,
  getState,
  workspaceId,
  action,
  edgeLabel = 'assets'
}) => {
  // iterate over the files

  const files = normalizeFiles(action.payload.files, action.payload.metadata);
  const parentResource =
    action.payload.parentResource ||
    ({
      type: 'folder',
      id: action.payload.parentFolderId
    } as ResourceIdentifier);
  const now = Date.now();

  files.forEach((f, idx) => {
    // this is just a placeholder,
    // will get overriden once the actual tus upload is created
    addFileStub(
      f,
      parentResource,
      dispatch,
      getState,
      now + idx,
      workspaceId,
      edgeLabel
    );

  });
};
